import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonusTotal, bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-pink-950 py-16 text-white md:py-24" data-id="element-13" data-mp="pj6c83lngiqh">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-14" data-mp="au1raenh00eo">
        <header className="mx-auto max-w-3xl text-center" data-id="element-15" data-mp="ftwkioupx22w">
          <h2 className="inline-flex flex-wrap items-center justify-center gap-3 text-3xl font-extrabold leading-tight tracking-tight text-white md:text-5xl" data-id="element-16" data-mp="fsbrj3o1xr75">
            <GiftIcon className="h-8 w-8 text-amber-300 md:h-10 md:w-10" aria-hidden="true" data-id="element-17" data-mp="5w8o7uhgrmim" />
            E in più, 3 Bonus inclusi
          </h2>
          <p className="mt-5 text-lg text-pink-100 md:text-xl" data-id="element-18" data-mp="3o3ps9z58duvv">
            Inclusi nel Kit durante l’offerta di lancio.
          </p>
        </header>

        <ul className="mt-12 grid gap-5 md:mt-16 lg:grid-cols-3" data-id="element-19" data-mp="1m9ywzejj2yyl">
          {bonuses.map(bonus => <li key={bonus.tag} className="flex h-full flex-col rounded-2xl bg-pink-900 p-6 ring-1 ring-pink-800 md:p-7" data-id="element-20" data-mp="1r8a59ku6d1ep">
              <span className="inline-flex w-fit items-center rounded-lg bg-amber-400 px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-pink-950" data-id="element-21" data-mp="3dfd0xeyzrsqr">
                {bonus.tag}
              </span>
              <h3 className="mt-5 text-xl font-extrabold leading-snug tracking-tight text-white" data-id="element-22" data-mp="3n5es4fmn5r9w">
                {bonus.title}
              </h3>
              <p className="mt-1 text-sm font-bold text-pink-300" data-id="element-23" data-mp="2zg3x7erz2r3o">{bonus.subtitle}</p>
              <p className="mt-4 text-pink-100" data-id="element-24" data-mp="2uhsoj7deymn1">{bonus.lead}</p>
              <p className="mt-3 font-extrabold tracking-tight text-amber-300" data-id="element-25" data-mp="38g0id6f5l7tz">
                {bonus.promise}
              </p>

              <ul className="mt-5 space-y-2.5" data-id="element-26" data-mp="33g49otvigs83">
                {bonus.includes.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-pink-100" data-id="element-27" data-mp="np01ay0nkmca">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-green-400" aria-hidden="true" data-id="element-28" data-mp="ipwtj5tag20m" />
                    <span data-id="element-29" data-mp="3chv4tp2jtam4">{item}</span>
                  </li>)}
              </ul>

              <p className="mt-auto flex items-center gap-3 pt-7" data-id="element-30" data-mp="3hgya9amfxium">
                <span className="text-sm text-pink-300 line-through" data-id="element-31" data-mp="3ljum8ihh6gpl">Valore: {bonus.value}</span>
                <span className="rounded-lg bg-green-500/15 px-3 py-1 text-sm font-extrabold uppercase text-green-400 ring-1 ring-green-500/40" data-id="element-32" data-mp="3qifmuj0n32ek">
                  Incluso oggi
                </span>
              </p>
            </li>)}
        </ul>

        <p className="mx-auto mt-12 w-fit rounded-2xl bg-pink-900 px-6 py-4 text-center text-lg font-extrabold uppercase tracking-wider text-amber-300 ring-1 ring-amber-500/40 md:text-xl" data-id="element-33" data-mp="2xujvzuxr44pp">
          Valore totale dei 3 Bonus: {bonusTotal}
        </p>
      </div>
    </section>;
}